// extracted by mini-css-extract-plugin
module.exports = {"container":"SessionIndicatorIcons_container__1m-iV","placeHolderShimmer":"SessionIndicatorIcons_placeHolderShimmer__3F52v","shimmer":"SessionIndicatorIcons_shimmer__14rbg"};